import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guards/auth.guard';
import {NoAuthGuard} from './guards/no-auth.guard';
import {AuthCallbackComponent} from './shared/auth-callback/auth-callback.component';
import {RegistrationAuthCallbackComponent} from './shared/auth-callback/registration-auth-callback.component';
import {VisitorGuard} from './guards/visitor.guard';
import {LanguageGuard} from './guards/language.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'setup-lang',
    // canActivate: [NoAuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setup-lang',
    canActivate: [LanguageGuard],
    loadChildren: () => import('./pages/settings-pages/setup-lang/setup-lang.module').then(m => m.SetupLangPageModule)
  }, {
    path: 'setup-lang/manual',
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./pages/settings-pages/setup-lang/setup-lang.module').then(m => m.SetupLangPageModule)
  }, {
    path: 'login',
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  }, {
    path: 'setup-profile',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/settings-pages/setup-profile/setup-profile.module').then(m => m.SetupProfilePageModule)
  }, {
    path: 'checkin-list/:type',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/checkin-list/checkin-list.module').then(m => m.CheckinListPageModule)
  }, {
    path: 'search-location',
    canActivate: [AuthGuard, VisitorGuard],
    loadChildren: () => import('./pages/search-location/search-location.module').then(m => m.SearchLocationPageModule)
  }, {
    path: 'check-in/:id',
    redirectTo: 'check-in-customer/:id',
    pathMatch: 'full'
  }, {
    path: 'chat/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/chat/chat.module').then(m => m.ChatPageModule)
  }, {
    path: 'eta/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/eta/eta.module').then(m => m.EtaPageModule)
  }, {
    path: 'setup-qr',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/settings-pages/setup-qr/setup-qr.module').then(m => m.SetupQrPageModule)
  }, {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/settings-pages/settings/settings.module').then(m => m.SettingsPageModule)
  }, {
    path: 'check-in-customer/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-in-customer/check-in-customer.module').then(m => m.CheckInCustomerPageModule)
  }, {
    path: 'check-in-customer/:id/:reservation',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-in-customer/check-in-customer.module').then(m => m.CheckInCustomerPageModule)
  }, {
    path: 'check-in-waiting/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-in-waiting/check-in-waiting.module').then(m => m.CheckInWaitingPageModule)
  }, {
    path: 'check-in-progress/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-in-progress/check-in-progress.module').then(m => m.CheckInProgressPageModule)
  }, {
    path: 'check-in-finished/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-in-finished/check-in-finished.module').then(m => m.CheckInFinishedPageModule)
  }, {
    path: 'check-in-registration/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-in-registration/check-in-registration.module').then(m => m.CheckInRegistrationPageModule)
  }, {
    path: 'check-out/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/check-in-pages/check-out/check-out.module').then(m => m.CheckOutPageModule)
  },
  {
    path: 'settings-menu',
    canActivate: [],
    loadChildren: () => import('./pages/settings-pages/settings-menu/settings-menu.module').then(m => m.SettingsMenuPageModule)
  },
  {
    path: 'settings-language',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/settings-pages/settings-language/settings-language.module').then(m => m.SettingsLanguagePageModule)
  },
  {
    path: 'code-select',
    loadChildren: () => import('./pages/code-select/code-select.module').then(m => m.CodeSelectPageModule)
  },
  {
    path: 'checkins-chats',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/checkins-chats/checkins-chats.module').then(m => m.CheckinsChatsPageModule)
  },
  {
    path: 'export-chat',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/checkins-chats/checkins-chats.module').then(m => m.CheckinsChatsPageModule)
  },
  {
    path: 'data-protection',
    loadChildren: () => import('./pages/settings-pages/data-protection/data-protection.module').then(m => m.DataProtectionPageModule)
  },
  {
    path: 'auth_callback',
    component: AuthCallbackComponent
  },
  {
    path: 'registration_auth_callback',
    component: RegistrationAuthCallbackComponent
  },
  {
    path: 'how-it-works',
    loadChildren: () => import('./pages/how-it-works/how-it-works.module').then( m => m.HowItWorksPageModule)
  },
  {
    path: 'pdf-view',
    loadChildren: () => import('./pages/pdf-view/pdf-view.module').then( m => m.PdfViewPageModule)
  },
  {
    path: 'upload-profile-picture',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/settings-pages/upload-profile-picture/upload-profile-picture.module').then(m => m.UploadProfilePicturePageModule)
  },
  {
    path: 'report',
    loadChildren: () => import('./pages/report/report.module').then( m => m.ReportPageModule)
  },
  {
    path: 'get-app',
    loadChildren: () => import('./pages/get-app/get-app.module').then( m => m.GetAppPageModule)
  },
  {
    path: 'reservations-list',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/reservations-list/reservations-list.module').then( m => m.ReservationsListPageModule)
  },
  {
    path: 'reservation/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/reservation/reservation.module').then( m => m.ReservationPageModule)
  },
  {
    path: 'reservation',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/reservation/reservation.module').then( m => m.ReservationPageModule)
  },
  {
    path: 'engineer',
    loadChildren: () => import('./pages/engineer/engineer.module').then(m => m.EngineerPageModule)
  },
  {
    path: 'imprint',
    loadChildren: () => import('./pages/settings-pages/imprint/imprint.module').then( m => m.ImprintPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/settings-pages/terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/settings-pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'permissions',
    loadChildren: () => import('./pages/settings-pages/permissions/permissions.module').then( m => m.PermissionsPageModule)
  },
  {
    path: 'cookie',
    loadChildren: () => import('./pages/settings-pages/cookie/cookie.module').then( m => m.CookiePageModule)
  },
  {
    path: 'permission',
    loadChildren: () => import('./pages/permission/permission.module').then( m => m.PermissionPageModule)
  },
  {
    path: 'share',
    loadChildren: () => import('./pages/share/share.module').then( m => m.SharePageModule)
  },
  {
    path: 'instant',
    loadChildren: () => import('./pages/instant-login/instant-login.module').then( m => m.InstantLoginPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
